import React from "react"
import { useTranslation } from "react-i18next"

export const Banner: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const {t} = useTranslation()
    return (
        <div>
            <div>
                <section className='banner banner-2 dinning-banner'>
                    <div className='overlay'></div>
                    <div className='container'>
                        <div className='banner-info banner-info-2'>
                            <div className='banner-details'>
                                <div className='banner-title'>
                                    <h1><span>{t(`navbar.${banner_title}`)}</span></h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}